export function updateSingleToMultiplePredicates(rule) {
    var _a;
    if ('Predicate' in rule && rule.Predicate) {
        rule.Predicates = [rule.Predicate, ...((_a = rule.Predicates) !== null && _a !== void 0 ? _a : [])];
        delete rule.Predicate;
    }
    return rule;
}
